// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2480) return "static/chunks/2480.2dc8c88f57ce68e9.js";
	if (chunkId === 9599) return "static/chunks/9599.4abbef6760c9382a.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1111":"65291039","2191":"13b8a98b","7439":"48c79778"}[chunkId] || chunkId) + "-" + {"1111":"0f07719c0acb9a5c","2191":"74a5399b707f9dde","3686":"60628330bd269b05","7439":"cbc8fa86c429d923"}[chunkId] + ".js";
};